import { Injectable } from '@angular/core';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class DiscardChangesService {
  hasUnsavedChanges: boolean = false;

  constructor(private modalService: NgbModal, private translate: TranslateService) { }

  setUnsavedChangesState(value: boolean) {
    this.hasUnsavedChanges = value;
  }

  getUnsavedChangesState() {
    return this.hasUnsavedChanges;
  }

  canDeactivate(): Promise<boolean> {

    if (!this.hasUnsavedChanges) {
      return Promise.resolve(true);
    }

    const modalRef = this.modalService.open(ConfirmationDialogComponent, {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.title = this.translate.instant('messages.unsaved_changes_message');
    modalRef.componentInstance.message = this.translate.instant('messages.you_will_lose_changes_message');
    modalRef.componentInstance.notConfirmActionLabel = this.translate.instant('buttons.cancel');
    modalRef.componentInstance.confirmActionLabel = this.translate.instant('buttons.confirm');

    return modalRef.result.then(
      (result) => {
        if(result) {
          this.hasUnsavedChanges = false;
        }
        return result;
      },
      (reason) => {
        this.hasUnsavedChanges = false;
        return false;
      }
    );
  }

}
